import {
	CancelScheduledInventoryTransferMutation,
	ScheduleInventoryTransferMutation
} from "~/gql/mutations/scheduledInventoryTransfers.generated";
import { GetScheduledInventoryTransfersQuery } from "~/gql/queries/scheduledInventoryTransfers.generated";

export const scheduledInventoryTransferEndpoints = {
	CancelScheduledInventoryTransfer: {
		invalidatesTags: ["ScheduledInventoryTransfers"] as AddTagTypes,
		transformResponse: (res: CancelScheduledInventoryTransferMutation) => res
	},
	GetScheduledInventoryTransfers: {
		providesTags: ["ScheduledInventoryTransfers"] as AddTagTypes,
		transformResponse: (res: GetScheduledInventoryTransfersQuery) => res
	},
	ScheduleInventoryTransfer: {
		invalidatesTags: ["ScheduledInventoryTransfers"] as AddTagTypes,
		transformResponse: (res: ScheduleInventoryTransferMutation) => res
	}
};
